export default "__VITE_ASSET__Ck0ZrImn__"